import type { ButtonHTMLAttributes } from 'react';
import { buttonClass, type ButtonStyleOptions } from './buttonStyles';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>, ButtonStyleOptions {
  isLoading?: boolean;
}

export function Button({
  variant,
  size,
  block,
  isLoading = false,
  disabled,
  children,
  className,
  ...rest
}: ButtonProps) {
  return (
    <button
      className={[buttonClass({ variant, size, block }), className].filter(Boolean).join(' ')}
      disabled={disabled || isLoading}
      {...rest}
    >
      {isLoading ? 'Cargando…' : children}
    </button>
  );
}
